import React, { useMemo } from 'react'
import { useParams } from 'react-router'

import { OrgUnitContext, OrgUnitReportAvailabilityContext } from '@percept/app-components'

import { useDataWarehouseAvailability, useDataWarehouseQueryGroupings } from 'components/DataWarehouse'

import { useOrgUnitProviderReportAvailability } from '@percept/hooks'

import {
  OrgUnitDataWarehouseAvailabilityContext,
  OrgUnitDataWarehouseAvailabilityContextValue,
} from 'contexts'

import { useActiveOrgEnvironment } from 'components/Organisation'


export const OrgUnitProvider = ({
  children,
  fallback = null
}: React.PropsWithChildren<{ fallback?: JSX.Element | null }>): JSX.Element | null => {
  const { activePlatformUnit } = useActiveOrgEnvironment()

  if( !activePlatformUnit ){
    return fallback
  }
  return (
    <OrgUnitContext.Provider value={activePlatformUnit}>
      { children }
    </OrgUnitContext.Provider>
  )
}


export const OrgUnitReportingAvailabilityProvider = ({
  children,
  orgUnitIdOverride,
}: React.PropsWithChildren<{ orgUnitIdOverride?: string }>) => {
  const { activePlatformUnit } = useActiveOrgEnvironment()
  
  const providerAvailability = useOrgUnitProviderReportAvailability({
    org_unit_id: orgUnitIdOverride || activePlatformUnit && activePlatformUnit.id,
    include_descendant_orgs: true,
  })

  return (
    <OrgUnitReportAvailabilityContext.Provider value={providerAvailability.data || null}>
      { children }
    </OrgUnitReportAvailabilityContext.Provider>
  )
}

export const OrgUnitDataWarehouseContextProvider = ({
  children,
  orgUnitIdOverride,
}: React.PropsWithChildren<{ orgUnitIdOverride?: string }>) => {

  const params = useParams<{org_unit_id: string}>()

  const reportGroupings = useDataWarehouseQueryGroupings()

  const availability = useDataWarehouseAvailability({
    org_unit_id: orgUnitIdOverride || params.org_unit_id,
  })

  const value: OrgUnitDataWarehouseAvailabilityContextValue = useMemo(() => {
    return {
      availability: availability.data || null,
      reportGroupings: reportGroupings.data || null,
    }
  }, [reportGroupings.data, availability.data])

  return (
    <OrgUnitDataWarehouseAvailabilityContext.Provider value={value}>
      { children }
    </OrgUnitDataWarehouseAvailabilityContext.Provider>
  )
}
